/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `lbs` - lbs
 */
export type WeightUnitEnum = typeof WeightUnitEnum[keyof typeof WeightUnitEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WeightUnitEnum = {
  lbs: 'lbs',
} as const;
